<template>
    <div class="container_reset">
        <div class="container">
            <h1>Nouveau mot de passe</h1>
            <p>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Cupiditate vero esse qui nostrum, itaque quis incidunt
                temporibus
            </p>
            <form @submit.prevent="validateBeforeSubmit" v-if="!onSend">
                <div class="form-group">
                    <input type="password" class="form-control form-control-lg" v-model="form.password" placeholder="Nouveau mot de passe" />
                    <span class="error" v-if="errors.password">{{ errors.password }}</span>
                </div>
                <div class="form-group">
                    <input type="password" class="form-control form-control-lg" v-model="form.confirm_password" placeholder="Confirmation du mot de passe" />
                    <span class="error" v-if="errors.confirm_password">{{ errors.confirm_password }}</span>
                </div>

                <button type="submit" class="btn btn-dark btn-lg btn-block">Modifier mon mot de passe</button>
            </form>

            <div v-if="onSend">
                <p>Le mot de passe a été modifié.</p>
            </div>
        </div>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    data() {
        return {
            onSubmit: false,
            onSend: false,
            errors: [],
            response: [],
            form: {
                password: null,
                confirm_password: null,
            },
        }
    },
    methods: {
        ...mapActions([
            'setOnLoad'
        ]),
        async validateResetPasswordToken() {
            this.$api.postResetTokenPassword({
                token: this.$route.params.token
            }).then(response => {
                this.response = response.data.message;
            }, response => {
                this.response = response.response.data.message;
                this.$router.push({ name: 'error', params: { code: '404' } })
            });
        },
        async validateBeforeSubmit() {
            if (this.onSend) return

            this.errors = []

            if (!this.form.password) {
                this.errors['password'] = 'Mot de passe requis'
            }
            if (!this.form.confirm_password) {
                this.errors['confirm_password'] = 'Confirmation du mot de passe requis'
            }
            if (this.form.password != this.form.confirm_password) {
                this.errors['confirm_password'] = 'Les mots de passe ne sont pas identiques'
            }

            if (!this.errors.length) {
                this.submit();
            }

            this.onSend = false
        },
        submit() {
            this.onSubmit = true
            // this.onSend = true
            this.setOnLoad(true)

            // Envoyer les mots de passe au BO.
            this.$api.postNewUserPassword({
                token: this.$route.params.token,
                password: this.form.password,
                confirm_password: this.form.confirm_password
            }).then(response => {
                this.response = response;
                this.onSend = true;
                this.setOnLoad(false);
            }).catch((response) => {
                this.response = response.response.data.message;
                this.errors['confirm_password'] = response.response.data.message;
                this.setOnLoad(false);
                this.onSubmit = false;
                this.onSend = false;
            });
        }
    },
    created() {
        // this.validateResetPasswordToken();
    },
}
</script>

<style lang="scss" scoped>
.container_reset {
    padding: 85px 0 50px;
}

.container {
    width: 100%;
    max-width: 700px;
    margin: 0 auto;
    padding: 0 20px;
}
</style>